// extracted by mini-css-extract-plugin
module.exports = {"fs0he67":"fs0he67","policy-acceptance":"policy-acceptance"};